import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type DeleteWatermarkTemplateMutationVariables = Types.Exact<{
  input: Types.DeleteWatermarkTemplateInput;
}>;


export type DeleteWatermarkTemplateMutation = { __typename?: 'Mutation', deleteWatermarkTemplate?: { __typename?: 'DeleteWatermarkTemplatePayload', watermarkTemplate?: { __typename?: 'WatermarkTemplate', id: string } | null } | null };


export const DeleteWatermarkTemplate = /*#__PURE__*/ gql`
    mutation DeleteWatermarkTemplate($input: DeleteWatermarkTemplateInput!) {
  deleteWatermarkTemplate(input: $input) {
    watermarkTemplate {
      id
    }
  }
}
    ` as unknown as DocumentNode<DeleteWatermarkTemplateMutation, DeleteWatermarkTemplateMutationVariables>;

          

          export const useDeleteWatermarkTemplateMutation = (options?:MutationHookOptions<DeleteWatermarkTemplateMutation, DeleteWatermarkTemplateMutationVariables>) => useMutation(DeleteWatermarkTemplate, options);
          

          export type DeleteWatermarkTemplateMutationOptions = MutationHookOptions<DeleteWatermarkTemplateMutation, DeleteWatermarkTemplateMutationVariables>;

          

          export type DeleteWatermarkTemplateMutationResult = ReturnType<typeof useDeleteWatermarkTemplateMutation>[1];

          
